<template>
    <ais-autocomplete
        class="relative z-0 flex w-full h-full transition-all duration-500"
        :class="active ? 'active md:w-80' : 'md:w-40 pr-5'"
    >
        <template v-slot="{ currentRefinement, indices, refine }">
            <div
                v-if="active"
                class="fixed top-0 left-0 w-full h-full"
                style="z-index: -2;"
                @click="
                    toggleActive(false);
                    if (currentRefinement) refine('');
                "
            ></div>

            <div class="flex items-center flex-grow text-blue-500">
                <input
                    type="text"
                    role="searchbox"
                    :value="currentRefinement"
                    class="flex-grow w-full mx-6 font-medium bg-transparent small"
                    placeholder="Search"
                    @input="
                        if ($event.currentTarget.value.trim().length >= 3)
                            refine($event.currentTarget.value);
                    "
                    @focus="toggleActive"
                />
                <a
                    class="flex-shrink-0 align-middle"
                    aria-label="Submit search query"
                    :href="'/search?query=' + currentRefinement"
                >
                    <!-- prettier-ignore -->
                    <svg width="15" height="15" viewbox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" focusable="false" aria-label="">
                        <circle cx="6" cy="6" r="5.25" stroke="currentColor" stroke-width="1.5" />
                        <path d="M9.35352 9.64642L13.707 14" stroke="currentColor" stroke-width="1.5" />
                    </svg>
                </a>
            </div>
            <transition name="shrink-horizontal">
                <button
                    v-if="active"
                    aria-label="Close search bar"
                    class="w-16 ml-6 bg-blue-500 button"
                    @click="
                        toggleActive(false);
                        if (currentRefinement) refine('');
                    "
                >
                    <svg
                        class="mx-auto"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        role="img"
                        focusable="false"
                        aria-label=""
                    >
                        <path
                            d="M15.6997 13.8891L14.639 14.9498L5.80018 6.11092L6.86084 5.05026L15.6997 13.8891Z"
                            fill="#fff"
                        />
                        <path
                            d="M15.6998 6.11092L6.86099 14.9498L5.80033 13.8891L14.6392 5.05026L15.6998 6.11092Z"
                            fill="#fff"
                        />
                    </svg>
                </button>
            </transition>

            <AutocompleteResults
                v-if="currentRefinement && active"
                :indices="indices"
                :currentRefinement="currentRefinement"
            />
        </template>
    </ais-autocomplete>
</template>

<script>
import { ref } from '@vue/composition-api';
import AutocompleteResults from './AutocompleteResults.vue';

export default {
    components: {
        AutocompleteResults
    },

    setup() {
        const active = ref(false);

        const toggleActive = (bool) => {
            active.value = bool;

            if (bool) {
                document.body.classList.add('search-active');
            } else {
                document.body.classList.remove('search-active');
            }
        };

        return {
            active,
            toggleActive
        };
    }
};
</script>

<style scoped>
input::placeholder {
    @apply text-blue-500 opacity-100;
}

.ais-Autocomplete .button {
    max-width: 90px;
}

.ais-Autocomplete:before {
    content: '';
    @apply absolute bg-white w-full h-full opacity-0 z-negative transition-opacity duration-500;
}

.ais-Autocomplete.active:before {
    @apply opacity-100;
}
</style>
